import { useMemo } from 'react'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'

import { QuickBuyInput } from './quick-buy-input'
import { getQuickBuySectionLabel } from './quick-buy-util'

import type { TradeSettingsQuick } from '@root/entities/trade-settings/model'
import type { ClassNameProps } from '@root/shared/react'

type QuickBuyInputSectionProps = {
  section: TradeSettingsQuick.QuickSwapSection
} & ClassNameProps

export const QuickBuyInputSection: React.FC<QuickBuyInputSectionProps> = ({
  section,
  className,
}) => {
  const label = useMemo(() => getQuickBuySectionLabel(section), [section])

  return (
    <Root className={className}>
      <Label ellipsis>{label}</Label>
      <QuickBuyInput
        section={section}
        withUsd={false}
        withLabel={false}
        withSettings={false}
        withPresetSelector={false}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;

  padding-inline: 14px 8px;
  padding-block: 8px;
  border-radius: 10px;
  border: 1px solid var(--background-4);
  background: var(--backgroundA-2);
`

const Label = styled(Typography)`
  color: var(--text-12);

  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
`
